module.exports = __webpack_public_path__ + "static/media/0016t.6004d83a.jpg";